import {cn} from '../../lib/utils';
import {Tooltip} from '../Tooltip';

import type {ComponentProps, ReactNode} from 'react';

export interface InfoTooltipProps {
  content?: ReactNode;
  side?: ComponentProps<typeof Tooltip>['side'];
  className?: string;
}

export function InfoTooltip({content, side, className}: InfoTooltipProps) {
  if (content == null) return null;

  return (
    <Tooltip content={content} side={side}>
      <span
        data-slot="info-tooltip"
        onClick={e => e.preventDefault()}
        className={cn(
          'inline-flex size-3.5 shrink-0 items-center justify-center rounded-full border border-border p-px',
          className
        )}
      >
        {/* text-box trims to cap height so flex centers the glyph; translate offsets "?"'s side bearing. */}
        <span className="text-[8px] leading-none font-bold translate-x-[0.5px] text-fg-quaternary [text-box:trim-both_cap_alphabetic]">
          ?
        </span>
      </span>
    </Tooltip>
  );
}
